module.exports = __webpack_public_path__ + "img/antenna.1cf328de.svg";